// components/ui/ImageUpload.jsx
import React from 'react';
import { Upload } from 'lucide-react';

const ImageUpload = ({ image, onImageChange, id, label = "Upload Image" }) => {
  return (
    <div>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-gray-400 cursor-pointer">
        <input
          type="file"
          accept="image/*"
          onChange={onImageChange}
          className="hidden"
          id={id}
        />
        <label htmlFor={id} className="cursor-pointer">
          {image ? (
            <img 
              src={image} 
              alt="Preview" 
              className="w-20 h-20 object-cover rounded mx-auto mb-2" 
            />
          ) : (
            <Upload size={32} className="mx-auto text-gray-400 mb-2" />
          )}
          <p className="text-gray-600">Click to upload or drag and drop</p>
          <p className="text-gray-500 text-sm">SVG, PNG, JPG or GIF (MAX. 800x400px)</p>
        </label>
      </div>
    </div>
  );
};

export default ImageUpload;